/** One-time tip asset creation. No canvas is used for a frame or watercolor. */
export function customTip(draw, angleMode='radians', size=256) {
  if(typeof draw!=='function')throw new TypeError('A custom brush requires a tip(surface) function.');
  if(!['radians','degrees'].includes(angleMode))throw new TypeError('Tip angle mode must be radians or degrees.');
  if(!Number.isInteger(size)||size<1||size>4096)throw new RangeError('Tip size must be an integer between 1 and 4096.');
  const canvas=typeof OffscreenCanvas!=='undefined'?new OffscreenCanvas(size,size):document.createElement('canvas');canvas.width=canvas.height=size;
  const ctx=canvas.getContext('2d');if(!ctx)throw new Error('Custom brush tips require Canvas2D.');
  let fill='black',stroke=null,lineWidth=1,mode=angleMode;
  const stack=[];
  const paint=()=>{if(fill!==null){ctx.fillStyle=fill;ctx.fill();}if(stroke!==null){ctx.strokeStyle=stroke;ctx.lineWidth=lineWidth;ctx.stroke();}};
  const css=x=>typeof x==='number'?'rgb('+x+','+x+','+x+')':x;
  const surface={canvas,drawingContext:ctx,width:size,height:size,
    pixelDensity:()=>1,noSmooth:()=>{ctx.imageSmoothingEnabled=false;},
    angleMode:x=>{if(!['radians','degrees'].includes(x))throw new TypeError('Tip angle mode must be radians or degrees.');mode=x;},
    background:x=>{ctx.save();ctx.resetTransform();ctx.fillStyle=css(x);ctx.fillRect(0,0,size,size);ctx.restore();},
    push:()=>{stack.push([fill,stroke,lineWidth,mode]);ctx.save();},
    pop:()=>{const s=stack.pop();if(s)[fill,stroke,lineWidth,mode]=s;ctx.restore();},
    translate:(x,y)=>ctx.translate(x,y),scale:(x,y=x)=>ctx.scale(x,y),
    rotate:a=>ctx.rotate(mode==='degrees'?a*Math.PI/180:a),
    fill:x=>{fill=css(x);},noFill:()=>{fill=null;},stroke:x=>{stroke=css(x);},noStroke:()=>{stroke=null;},strokeWeight:w=>{lineWidth=w;},
    rect:(x,y,w,h)=>{ctx.beginPath();ctx.rect(x,y,w,h);paint();},
    circle:(x,y,d)=>{ctx.beginPath();ctx.arc(x,y,d/2,0,Math.PI*2);paint();},
    ellipse:(x,y,w,h)=>{ctx.beginPath();ctx.ellipse(x,y,w/2,h/2,0,0,Math.PI*2);paint();},
    line:(x,y,u,v)=>{ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(u,v);if(stroke!==null){ctx.strokeStyle=stroke;ctx.lineWidth=lineWidth;ctx.stroke();}},
    triangle:(x,y,u,v,a,b)=>{ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(u,v);ctx.lineTo(a,b);ctx.closePath();paint();},
    beginShape:()=>ctx.beginPath(),vertex:(x,y)=>ctx.lineTo(x,y),endShape:closed=>{if(closed)ctx.closePath();paint();},
    bezier:(x,y,a,b,c,d,u,v)=>{ctx.beginPath();ctx.moveTo(x,y);ctx.bezierCurveTo(a,b,c,d,u,v);paint();},
  };
  ctx.fillStyle='white';ctx.fillRect(0,0,size,size);
  ctx.translate(size/2,size/2);ctx.scale(size/100,size/100);
  const value=draw(surface);if(value?.then)throw new TypeError('Custom tip callbacks must be synchronous.');return canvas;
}
export function loadImage(src) {
  if(typeof src!=='string'||!src.trim())return Promise.reject(new TypeError('Brush tip source must be a nonempty URL string.'));
  return new Promise((resolve,reject)=>{
    const image=new Image();image.crossOrigin='anonymous';
    const finish=()=>{image.onload=image.onerror=null;};
    image.onload=()=>{finish();resolve(image);};image.onerror=()=>{finish();reject(new Error('Could not load brush tip: '+src));};image.src=src;
  });
}
export function uploadTip(gl, image) {
  const width=image?.videoWidth??image?.naturalWidth??image?.width,height=image?.videoHeight??image?.naturalHeight??image?.height;
  if(!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0)throw new TypeError('A brush tip requires a loaded image or a nonempty canvas.');
  const texture=gl.createTexture();
  if(!texture)throw new Error('Could not allocate a brush tip texture.');
  try {
  gl.activeTexture(gl.TEXTURE0);gl.bindSampler(0,null);
  gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER,null);
  gl.pixelStorei(gl.UNPACK_ALIGNMENT,1);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,false);
  gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL,false);
  for(const key of ['UNPACK_ROW_LENGTH','UNPACK_IMAGE_HEIGHT','UNPACK_SKIP_PIXELS','UNPACK_SKIP_ROWS','UNPACK_SKIP_IMAGES'])gl.pixelStorei(gl[key],0);
  gl.bindTexture(gl.TEXTURE_2D,texture);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
  return texture;
  }catch(error){gl.deleteTexture(texture);throw error;}
}
